import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useState, useEffect } from 'react';

const Success = ({ msg }) => {
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplay(false);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  return (
    display && (
      <Stack
        sx={{
          width: 'auto',
          maxWidth: '80%',
          position: 'fixed',
          bottom: '5%',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 2000,
        }}
        spacing={2}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          {msg ? msg : "Success! Refresh to see updated data."}
        </Alert>
      </Stack>
    )
  );
};

export default Success;